import {
  FieldError,
  Input,
  Label,
  Text,
  TextField as AriaTextField,
  type TextFieldProps as AriaTextFieldProps,
} from 'react-aria-components';

import '../Field/Field.css';

export interface TextFieldProps extends Omit<
  AriaTextFieldProps,
  'children' | 'className' | 'style'
> {
  /** Always visible above the field. A placeholder is not a label: it
   * disappears as soon as the operator types. */
  label: string;
  /** A hint that prevents a mistake: format, units, where to find the value. */
  description?: string;
  /** Shown instead of the description when the value is rejected. Say how to
   * fix it: "Enter an IPv4 address like 10.0.0.1". */
  errorMessage?: string;
  /** An example value, never instructions. */
  placeholder?: string;
  type?: 'text' | 'email' | 'password' | 'url' | 'tel';
}

/** TextField is a labelled single-line input with its hint and error. */
export function TextField({
  label,
  description,
  errorMessage,
  placeholder,
  type = 'text',
  ...props
}: TextFieldProps) {
  return (
    <AriaTextField
      {...props}
      type={type}
      className="rs-field"
      {...(errorMessage ? { isInvalid: true } : {})}
    >
      {/* No asterisk on required fields: most fields are required, so the
          mark is noise. Say "(optional)" in the label of the few that are not. */}
      <Label className="rs-field__label">{label}</Label>
      <div className="rs-input">
        <Input {...(placeholder ? { placeholder } : {})} />
      </div>
      {errorMessage ? (
        <FieldError className="rs-field__error">{errorMessage}</FieldError>
      ) : (
        description && (
          <Text slot="description" className="rs-field__description">
            {description}
          </Text>
        )
      )}
    </AriaTextField>
  );
}
